export class WikiPostsStatisticsDTO {

    posts: {
        latest: Array<any>;
        oldest: Array<any>;
        popular: Array<any>;
    };

    categories: {
        largest: Array<any>;
    };

    authors: {
        top: Array<any>;
    };

    editors: {
        top: Array<any>;
    };

}
